import React from 'react';
import helpContent from '../content/helpContent.json';

export function helpSectionsForRole(role) {
  return helpContent.filter(section => section.roles.includes(role));
}

export function HelpNode({ node, role }) {
  if (typeof node === 'string') return node;
  if (!node.roles.includes(role)) return null;
  const children = node.children.map((child, index) => <HelpNode key={index} node={child} role={role} />);
  if (node.tag === 'fragment') return <>{children}</>;
  return React.createElement(node.tag, { id: node.id, className: node.className }, children);
}
